export default __webpack_public_path__ + "static/media/trustWallet.123a2360.svg";